import { EVENT_FORM_SUBMIT, EVENT_FORM_SUBMIT_DETAIL } from '~~/constants/googleTagManager';
import type { TriggerFormSubmitParameters } from '~~/types/integrations/tagManager/TagManagerIntegration';

export const buildFormSubmitTags = ({ reason }: TriggerFormSubmitParameters) => ({
  event: EVENT_FORM_SUBMIT,
  event_info: {
    detail: EVENT_FORM_SUBMIT_DETAIL,
    reason,
  },
});
